export const dataFormatada = (data = null) => {
    const dataObj = data ? new Date(data) : new Date();
    
    if (isNaN(dataObj.getTime())) {
        // Se a data for inválida, retorna data atual
        const agora = new Date();
        const dia = String(agora.getDate()).padStart(2, '0');
        const mes = String(agora.getMonth() + 1).padStart(2, '0');
        const ano = agora.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }
    
    const dia = String(dataObj.getDate()).padStart(2, '0');
    const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
    const ano = dataObj.getFullYear();
    return `${dia}/${mes}/${ano}`;
};
  